<template>
  <div class="container3">
    <div class="result-container" v-if="showResult">
      <div
        :style="{
          background: `no-repeat center/contain url(${imgUrl2})`,
          backgroundColor: '#000',
          width: '100%',
          height: '100%',
        }"
      ></div>
      <div @click="preview" class="primitive">查看原图</div>
    </div>

    <div
      v-if="!showResult"
      class="pic-container"
    >

      <div class="tip">请拍摄并上传你的车辆损坏处图片</div>
      <div class="pic-stage" @click="preview">
        <div
          v-if="imgUrl"
          :style="{
            background: `no-repeat center/contain url(${imgUrl})`,
            width: '100%',
          }"
        ></div>
        <div v-if="!imgUrl" class="cover">
          <van-uploader :after-read="afterRead" />
          <img
            src="https://oss.turingsenseai.com/1703054060020142554.jpg"
            alt=""
          />
        </div>
        <div v-if="!imgUrl" class="upload-text">点击拍摄/上传图片</div>
      </div>
    </div>

    <div class="tip" v-if="!showResult">
      <div class="title">拍摄注意事项</div>
      <div>
        <div class="item">1、请确保图片清晰，避免模糊影响图像识别。</div>
        <div class="item">2、需将车辆损坏处尽量保持在画面中间。</div>
        <div class="item">3、请保持摄像头与车辆的适当距离，避免过近的拍摄视角</div>
        <div class="item">4、避开强光反光，确保照片清晰。</div>
        <div class="item">5、参考图片：</div>
        <img 
          @click="previewSample"
        width="90" src="https://oss.turingsenseai.com/1703139489730899540.jpg" alt="">
      </div>
    </div>

    <div class="list" v-if="showResult">
      <div v-for="(a,index) in results" class="wrap"> 
        <div class="tag">序号: {{index}}</div>
        <div class="item" style="margin-bottom: 10px;margin-top: 15px;">
          <div class="item1">损伤等级</div>
          <div class="item2">{{a.damageLevel}}</div>
        </div>
        <div class="item">
          <div class="item1">部件名称</div>
          <div class="item2">{{a.partName}}</div>
        </div>
      </div>

      <div style="height: 200px;width:100px;"></div>
    </div>

    <!-- <div class="bbbb" v-if="!success">
      <span class="bb">提交即阅读且同意</span> <a href="https://baoh5.turingsenseai.com/#/static-page/appraisal-notice">《包小鉴AI极速鉴别协议》</a>
    </div> -->

    <div class="bottom">

      <div v-if="success" class="btn back gradient" @click="back">返回首页</div>
  
      <div v-if="!takePhoto" class="btn back gradient">
        <van-uploader :after-read="afterRead" />
        <span>上传图片</span>
      </div>

      <div v-if="takePhoto && !success" class="btn back">
        <van-uploader :after-read="afterRead" />
        <span>重新上传</span>
      </div>
  
      <div v-if="takePhoto && !success" class="btn back gradient" @click="submit">
        <span>开始鉴定</span>
      </div>
  

    </div>


    <van-overlay :show="show">
      <div class="scan-wrapper">
        <div class="qr-scanner">
          <div class="box">
            <div class="line"></div>
            <div class="angle"></div>
          </div>
        </div>
        <div class="img">
          <img :src="imgUrl" alt="" />
        </div>
      </div>
    </van-overlay>

    <canvas-poster
      :widthPixels="0"
      :painting="painting"
      @success="successPainting"
      @fail="fail"
    ></canvas-poster>
  </div>
</template>
<script>
// https://oss.turingsenseai.com/1642666019819575341.png
//https://oss.turingsenseai.com/1642666038510779975.png
import { Toast, ImagePreview } from "vant";
import { uploadImage } from "../../common/api/common";
import { vehicleDamage, upload } from "@/common/api/ps";
import {CanvasPoster} from './plugin';


// Toast.setDefaultOptions({ duration: 2000 });
export default {
  components: {
    CanvasPoster,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      takePhoto: false,
      success: false,
      loading: false,
      imgUrl: null,
      showResult: false,
      show: false,
      data: {},
      painting: null,
      imageInfo: {},
      imgUrl2: null,
      results: [],
      id: null,
      loadingInstance: null
    };
  },
  methods: {
    frame({
      type,
      label,
      left,
      top,
      width,
      height,
    }){
      const r = this.imageInfo.height / 480;

       
      return [
        {
          type: 'text',
          text: label,
          css: {
            top:  (top - 11 * r) + 'px',
            color: type === 'part' ? '#000' :'#fff',
            background: type === 'part' ? '#D9D9D9' : '#3B95FF',
            left: (left + 2) + 'px',
            fontSize: r * 10 + 'px',
            padding: '2px 3px'
          }
        },
        {
          type: "rect",
          css: {
            width: width + 'px',
            height: height + 'px',
            top: top + 'px',
            left: left + 'px',
            borderWidth: '1px',
            borderColor: type === 'part' ? '#D9D9D9' : '#3B95FF',
            color: 'rgba(0, 0, 0, 0)'
          },
        }
      ]
    },
    uploadAgain() {
      this.takePhoto = false;
      this.imgUrl = null;
    },
    async afterRead(file) {
      if (file && file.file.size > 10 * 1024 * 1024) {
        Toast("图片大小不能超过10M");
        return;
      }

      var url = URL.createObjectURL(file.file);
      var img = new Image;

      img.onload = ()=>{
          this.imageInfo = {height: img.height, width: img.width}
          URL.revokeObjectURL(img.src);
      };

      img.src = url;

      const instance = Toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
        onOpened: async () => {
          const res = await uploadImage({
            imgB64: file.content.split(",")[1],
          }).catch(() => {
            console.log('@@@@@@@@@@@');
            instance.clear();
            return {};
          });
          console.log(res, '----------------------');
          if (res.errorMsg === "Success") {
            this.load(res.imageUrl).then(() => {
              this.imgUrl = res.imageUrl;
              this.takePhoto = true;
              this.showResult = false
              instance.clear();
            });
          }
        },
      });
    },
    preview() {
      if (this.imgUrl2) {
        ImagePreview({
          images: [this.imgUrl2],
          showIndex: false,
          closeable: true,
        });
      }
    },
    async fail(err) {
      console.log(err);
      // this.showResult = false;
    },
    async successPainting(src) {
      this.imgUrl2 = src;
      this.showResult = true;
      this.loadingInstance.clear();
      uploadImage({
        imgB64: src.split(",")[1],
      }).then((res)=>{
        if (res.errorMsg === "Success") {
          upload({image_url:res.imageUrl,id:this.id })
        }
      });
    },
    async previewSample(){
      ImagePreview({
        images: ['https://oss.turingsenseai.com/1703139489730899540.jpg'],
        closeable: true,  
      });
    },
    async submit(e) {

      this.loadingInstance = Toast.loading({
        message: "识别中...",
        forbidClick: true,
        duration: 0,
        onOpened: async () => {
          vehicleDamage({
            image: this.imgUrl,
          }).then((res)=>{
            if(res.errorMsg === 'Success'){
              this.results = res.results;
              this.id = res.id;
              this.painting = {
                  background: this.imgUrl,
                  width: this.imageInfo.width + "px",
                  height: this.imageInfo.height + "px",
                  views: res.results.map((v, index) => {
                    return [
                      ...this.frame({
                        width: v.damagePosition.wight,
                        height: v.damagePosition.height,
                        label: '序号' + index + ':' + v.damageLevel,
                        left:  v.damagePosition.xmin,
                        top: v.damagePosition.ymin
                      }),
                      ...this.frame({
                        type: 'part',
                        width: v.partPosition.wight,
                        height: v.partPosition.height,
                        label: v.partName,
                        left:  v.partPosition.xmin,
                        top: v.partPosition.ymin
                      }),
                    ]
                  }).flat(),
                };
              }
            }).catch(()=>{
              this.loadingInstance.clear();
            })

        },
      });
    

    },
    load(src) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener("load", resolve);
        image.addEventListener("error", reject);
        image.src = src;
      });
    },
    back() {
      this.$router.replace("/appraisal/ps");
    },
  },
};
</script>

<style lang="scss">
.container3 {
  height: 100vh;
  position: absolute;
  left: 0;
  right: 0;
  background: #f5f6fa;
  // width: 100vw;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -2;
  }

  .btn-wrapper > div {
    display: flex;
    justify-content: center;
    margin-top: 100px;
  }

  .btn {
    width: 654px;
    height: 96px;
    border-radius: 200px;
    background: #efeff4;
    color: #3a3d44;
    text-align: center;
    line-height: 96px;
    font-weight: 500;
    font-size: 34px;
  }

  .back {
    margin: 0 20px;
    // margin: 0 auto;
    // margin-top: 52px;
  }

  .bbbb {
    text-align: center;
    font-size: 24px;
    .bb {
      color: #828393;
    }
  }

  .result-container {
    width: 100%;
    height: 597px;
    position: relative;
    margin-bottom: 30px;
    .primitive{
      padding: 10px 30px;
      background-color: #0000008c;
      color: #fff;
      position: absolute;
      bottom: 20px;
      right: 30px;
      border-radius:50px;
    }
  }

  .pic-container {
    
    width: 654px;
    // height: 520px;
    position: relative;
    margin: 80px auto 80px auto;

    .tip {
      // text-align: center;
      color: #3a3d44;
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 30px;
    }
    .pic-stage {
      width: 654px;
      height: 520px;
      border-radius: 16px;
      display: flex;
      justify-content: center;
      overflow: hidden;
      z-index: 20;
      // background: linear-gradient(
      //   190.61deg,
      //   rgba(255, 255, 255, 0.52) 19.29%,
      //   rgba(248, 248, 255, 0.8) 54.41%,
      //   rgba(255, 255, 255, 0.77) 90.02%
      // );
      background: #fff;
      // box-shadow: -8.22948px 39.9926px 115.213px rgba(58, 148, 255, 0.11);
      backdrop-filter: blur(15.636px);
      .cover {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: relative;

        .van-uploader {
          left: 0;
          height: 100%;
          .van-uploader__wrapper {
            height: 100%;
            .van-uploader__upload {
              height: 100%;
            }
          }
        }
       
        img {
          width: 306px;
          background: rgba(163, 205, 255, 0.02);
          // box-shadow: inset 0px 0px 100px rgba(50, 135, 255, 0.11);
          // box-shadow: 0px 0px 100px rgba(50, 135, 255, 0.11);
          border-radius: 5px;
          // position: absolute;
          // position: relative;
          // bottom: 86px;
        }
      }
      .upload-text{
        font-size: 32px;
        font-weight: 400;
        text-align: center;
        color: #999999;
        position: absolute;
        bottom: 40px;
      }
    }
    .text {
      position: absolute;
      opacity: 0.5;
      top: -70px;
      left: 50px;
      z-index: -1;
      img {
        width: 160px;
      }
    }
  }

  .tip{
    width: 654px;
    margin: 0 auto;
    .title{
      font-size: 32px;
      font-weight: 600;
      text-align: left;
      margin: 20px 0px;
    }
    .item{
      font-size: 28px;
      font-weight: 400;
      color: #999999;
      margin-bottom: 15px;
    }
  }

  .list{
    width: 690px;
    margin: 0 auto;
    .tag {
      font-size: 20px;
      color: #fff;
      background: #3B95FF;
      position: absolute;
      left: 0;
      top: 0;
      padding: 5px 20px;
      border-radius:0px 0px 25px 0px;
    }
    .wrap{
      margin-bottom: 20px;
      border-radius: 25px;
      background: #fff;
      padding: 20px 40px;
      overflow: hidden;
      position: relative;
    }
    .item {
      display: flex;
      justify-content: space-between;
    }
    .item1{
      color: #999999;
      font-size: 32px;
      font-weight: 500;
    }
    .item2{
      font-size: 32px;
      font-weight: 500;
      color: #000;
    }
  }

  .bottom {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: #fff;
    height: 180px;
    display: flex;
    // align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 20px 0px;
  }

  .gradient {
    background: linear-gradient(270deg, #3a94ff 0%, #74c8f5 100%);
    font-style: normal;
    color: #fff;
    background: linear-gradient(270deg, #3a94ff 6.84%, #74c8f5 93.49%);
    box-shadow: 0px 2px 60px rgba(23, 137, 255, 0.2);
    position: relative;
  }

  .van-overlay {
    background: rgba(0, 0, 0, 0.8);
  }

  .van-uploader {
    position: absolute;
    width: 100%;
    left: 100px;

    .van-uploader__wrapper {
      width: 100%;
      .van-uploader__upload {
        width: 100%;
        .van-icon-photograph::before {
          content: "";
        }
        margin: unset;
        height: 96px;
        width: 614px;
        opacity: 0;
      }
    }
  }

  .scan-wrapper {
    .qr-scanner {
      position: absolute;
      top: 0;
      z-index: 100;
      background: rgba(255, 255, 255, 0);
      background-image: linear-gradient(#0ba8fc1e 1px, transparent 0),
        linear-gradient(90deg, #0ba8fc1e 1px, transparent 0);
      background-size: 25px 25px;
      width: 100%;
      height: 100%;
      animation: scanner-bg 3s infinite;
    }

    .qr-scanner .box {
      width: 85vw;
      height: 100vh;
      max-height: 85vh;
      max-width: 85vh;
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden;
    }

    .qr-scanner .line {
      // height: calc(100% - 2px);
      height: 200px;
      width: 100%;
      background: linear-gradient(180deg, #3a93ff00 43%, #1fb0ffd0 211%);
      border-bottom: 10px solid #0073ffd0;
      transform: translateY(-100%);
      animation: radar-beam 3s infinite;
      animation-timing-function: cubic-bezier(0.53, 0, 0.43, 0.99);
    }

    .qr-scanner .box:after,
    .qr-scanner .box:before {
      top: 0;
      border-top-color: #00ff33;
    }

    .qr-scanner .angle:after,
    .qr-scanner .angle:before {
      bottom: 0;
      border-bottom-color: #00ff33;
    }

    .qr-scanner .box:before,
    .qr-scanner .angle:before {
      left: 0;
      border-left-color: #00ff33;
    }

    .qr-scanner .box:after,
    .qr-scanner .angle:after {
      right: 0;
      border-right-color: #00ff33;
    }

    @keyframes radar-beam {
      0% {
        transform: translateY(-100%);
        opacity: 1;
      }

      100% {
        transform: translateY(100vh);
        opacity: 0.3;
      }
    }

    @keyframes scanner-bg {
      0% {
        opacity: 0;
      }

      70% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }

    .img {
      width: 100vw;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      // background-image: url('https://scpic.chinaz.net/files/pic/pic9/202201/apic37929.jpg');
      // background-size: contain;
      // background-repeat: no-repeat;
      // background-position: center;
    }
  }
}
</style>
